import { render, staticRenderFns } from "./ClientsProblem.vue?vue&type=template&id=a71c5642"
import script from "./ClientsProblem.vue?vue&type=script&lang=js"
export * from "./ClientsProblem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports